import { useTranslation } from "react-i18next";

import { useAlertStore } from "~/stores/use-alert-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

export default function Alert() {
  const { isOpen, message, title, closeDialog, buttons, canClose } =
    useAlertStore();

  const { t } = useTranslation("common");

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(isOpen) => {
        if (isOpen === false) {
          closeDialog();
        }
      }}
    >
      <DialogContent
        className="max-w-xl w-full"
        onInteractOutside={(e) => {
          if (canClose === false) {
            e.preventDefault();
          }
        }}
      >
        <DialogHeader canClose={false}>
          <DialogTitle>{title ?? t("alert_title")}</DialogTitle>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <span className="text-center">{message ?? t("alert_message")}</span>
        </div>
        <DialogFooter>
          {buttons.map((button) => (
            <Button
              variant={button.variant}
              onClick={() => {
                closeDialog(button.value);
              }}
            >
              {button.label}
            </Button>
          ))}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
